import React from "react";
import { View } from "web/react/emo/view";
import * as styles from "./product-image.css";

interface ProductImageProps {
    src: string;
    alt: string;
    lazy?: boolean;
}

// TODO BEAM-1144: Refactor ProductCardImage to utilise this component

export function ProductImage({ src, alt, lazy = true }: ProductImageProps): JSX.Element {
    return (
        <View background="placeholder" padding="xxs">
            <img src={src} alt={alt} className={styles.image} loading={lazy ? "lazy" : "eager"} />
        </View>
    );
}
